import { TableColumn, TableRow } from '@/components/Table/types';
import { Trans } from 'react-i18next';

export const processesCountColumnConfig = <T extends TableRow>(
  options?: Omit<TableColumn<T>, 'id' | 'label'>,
): TableColumn<T> => ({
  id: 'processesCount',
  label: <Trans i18nKey="processes" />,
  acessorKey: 'processesCount',
  sortable: true,
  ...options,
});
